import { Routes, Route } from "react-router-dom";
import "./App.css";
import "@heartlandone/vega/style/vega.css";
import Home from "./component/Home";

function App() {
  return (
    <Routes>
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default App;
